import {
  PresetSection,
  PresetSectionBuilder,
  PresetSectionItem,
  PresetSectionItemBuilder,
} from '@wix/add-panel-common';
import React, { FC, useRef, useState } from 'react';
import { useUtils } from '../../../../../../UtilsProvider';
import { SectionHeader } from '../../../../SectionHeader';
import { PresetItem } from '../../../PresetSection/PresetItem';
import styles from './BlankSection.scss';
import type { BlankSectionProps } from './BlankSection.types';

export const BlankSection: FC<BlankSectionProps> = () => {
  const { getBlankSectionStructure } = useUtils();

  const [[section, item]] = useState<[PresetSection, PresetSectionItem]>(() => [
    new PresetSectionBuilder().build(),
    new PresetSectionItemBuilder()
      .withPresetLabel('Blank Section')
      .withPresetRect({ x: 0, y: 0, height: 100, width: 304 })
      .withStructure(getBlankSectionStructure({ height: 400, y: 200 }))
      .build(),
  ]);

  const { automationId } = section;

  const sectionImageRef = useRef(null);

  return (
    <div data-hook={automationId} className={styles.section}>
      <SectionHeader headerText="Blank Section" title="Blank Section" shouldTranslate={false} disableInfoIcon />

      <div className={styles.items}>
        <PresetItem item={item} section={section} sectionIndex={0} index={0} sectionImageRef={sectionImageRef} />
      </div>
    </div>
  );
};
